import { createSlice } from '@reduxjs/toolkit';
import { initialRolesState } from 'reducers/initialStates';

const rolesSlice = createSlice({
	name: 'roles',
	initialState: {
		//Set by configureStore
	},
	reducers: {
		setRolesPermAssignedList(state, action) {
			state.rolesPermAssignedList = action.payload;
		},
		setRolesPermAssignedListRoleId(state, action) {
			state.rolesPermAssignedListRoleId = action.payload;
		},
		resetRolesPermAssignedList(state) {
			state.rolesPermAssignedList = [];
			state.rolesPermAssignedListRoleId = null;
		},
		resetRolesSlice() {
			return initialRolesState;
		}
	}
});

export const {
	setRolesPermAssignedList,
	setRolesPermAssignedListRoleId,
	resetRolesPermAssignedList,
	resetRolesSlice
} = rolesSlice.actions;

export default rolesSlice.reducer;

export const rolesPermAssignedListSelector = state => state.roles.rolesPermAssignedList;
export const rolesPermAssignedListRoleIdSelector = state => state.roles.rolesPermAssignedListRoleId;
